import React from 'react'
import { withTranslation } from 'react-i18next'

import withReduxModal from '../../../modules/redux-modal/redux/withReduxModal'
import { PORTAL_CREATE_MODAL } from '../../../constants/modalType'

const PortalListActionPanel = ({ onCreateClick, modalActions, i18n }) => {
  return (
    <div className="has-text-right">
      <button
        className="button is-primary"
        onClick={() => modalActions.showModal(PORTAL_CREATE_MODAL)}
      >
        <span className="icon">
          <i className="fas fa-plus" aria-hidden="true" />
        </span>
        <span>
          <strong>{i18n.t('actions.create.label')}</strong>
        </span>
      </button>
    </div>
  )
}

export default withTranslation()(withReduxModal(PortalListActionPanel))



// WEBPACK FOOTER //
// ./src/components/templates/portal-list/PortalListActionPanel.js